import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { getRmaReasons } from "@store/Services/RmaReasonsService";

export const FetchRmaReasons: Handler = async ({ dispatch }) => {
    const untypedDispatch: any = dispatch;
    const reasonsResults = await getRmaReasons();
    untypedDispatch({
        type: "Data/RmaReasons/RmaReasons",
        parameter: reasonsResults,
    });
};

export const chain = [FetchRmaReasons];

const fetchRmaReasons = createHandlerChainRunner(chain, "FetchRmaReasons");
export default fetchRmaReasons;
